/* stl.js — AJAX "in den Warenkorb" für Shop-the-Look Teile-Zeilen.
   Kein jQuery, keine Abhängigkeiten. Fügt Variante hinzu und gibt
   kurzes visuelles Feedback am Button. Fällt bei Fehler auf die
   Standard-/cart-Seite zurück. */
(function () {
  "use strict";

  function feedback(btn, text, ms) {
    var tt = btn.querySelector(".tt");
    if (!tt) return;
    if (!btn.dataset.stlLabelHtml) btn.dataset.stlLabelHtml = tt.innerHTML;
    tt.textContent = text;
    var arw = btn.querySelector(".arw");
    if (arw) arw.textContent = "✓";
    window.clearTimeout(btn._stlT);
    btn._stlT = window.setTimeout(function () {
      tt.innerHTML = btn.dataset.stlLabelHtml;
      if (arw) arw.textContent = "+";
    }, ms || 1600);
  }

  function bumpBubble(count) {
    document.querySelectorAll(
      ".cart-count-bubble, [data-cart-count], .cart-count, #CartCount"
    ).forEach(function (el) {
      var span = el.querySelector("span") || el;
      span.textContent = count;
      el.setAttribute("aria-label", count + " Artikel im Warenkorb");
    });
    document.dispatchEvent(new CustomEvent("stl:cart-updated", { detail: { count: count } }));
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-stl-atc]");
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector("button[type=submit]");
    if (btn) btn.setAttribute("disabled", "disabled");

    var body = new FormData(form);
    fetch(form.action, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: body
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        return fetch("/cart.js", { headers: { Accept: "application/json" } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === "number") bumpBubble(cart.item_count);
        if (btn) { btn.removeAttribute("disabled"); feedback(btn, "im Warenkorb"); }
      })
      .catch(function () {
        // Fallback: klassisch zur Warenkorbseite
        if (btn) btn.removeAttribute("disabled");
        window.location.href = "/cart";
      });
  });
})();
